(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_video-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.TecMediaCards) return;
    const selector = '[data-tec-media-card]';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const visible = new WeakSet();
    const list = (root) => [
      ...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)
    ];

    // Templates keep both images and video sources inert until the card is near view.
    const mount = (card) => {
      card.querySelectorAll('template').forEach((template) => {
        const media = template.content.firstElementChild;
        const isVideo = media.tagName === 'VIDEO';
        const ready = () => card.classList.add(...(isVideo ? ['is-ready', 'is-video-ready'] : ['is-ready']));
        media.addEventListener(isVideo ? 'loadeddata' : 'load', ready, { once: true });
        media.addEventListener('error', () => card.classList.add('is-ready'), { once: true });
        if (isVideo) media.muted = media.defaultMuted = true;
        template.replaceWith(media);
        if (!isVideo && media.complete) ready();
      });
      if (!card.querySelector('.tec-video-card__gif, video')) card.classList.add('is-ready');
    };

    const update = (card) => {
      const active = visible.has(card) && !document.hidden;
      if (active) mount(card);
      const video = card.querySelector('video');
      if (!video) return;
      if (active && !motion.matches) video.play()?.catch(() => {});
      else video.pause();
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) visible.add(target);
        else visible.delete(target);
        update(target);
      });
    }, { rootMargin: '100px' }) : null;

    const start = (root) => list(root).forEach((card) => {
      if (card.dataset.tecReady) return;
      card.dataset.tecReady = '1';
      if (observer) observer.observe(card);
      else { visible.add(card); update(card); }
    });
    const refresh = () => list(document).forEach(update);
    window.TecMediaCards = { start };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
    } else start(document);
    document.addEventListener('shopify:section:load', ({ target }) => start(target));
    document.addEventListener('shopify:section:unload', ({ target }) => list(target).forEach((card) => {
      observer?.unobserve(card);
      visible.delete(card);
      update(card);
      delete card.dataset.tecReady;
    }));
    document.addEventListener('visibilitychange', refresh);
    motion.addEventListener('change', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
